import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { MarketmakingTableTabs } from "src/Interfaces/marketmaking";
import {
  IExecusionSearchParams,
  ITaskTableReport,
} from "src/Interfaces/automaticMarketMaking";

enum ModalMode {
  Closed,
  Setting,
  AddOrEdit,
}
interface IAutomaticMarketMakingSlice {
  taskRow: ITaskTableReport | null;
  editTask: IExecusionSearchParams;
  isEdit: boolean;
  modalMode: ModalMode;
  tabIndex: MarketmakingTableTabs;
}

const initialState: IAutomaticMarketMakingSlice = {
  taskRow: {} as ITaskTableReport,
  editTask: {} as IExecusionSearchParams,
  isEdit: false,
  modalMode: ModalMode.Closed,
  tabIndex: MarketmakingTableTabs.OrderTable,
};

const AutomaticMarketMakingSlice = createSlice({
  name: "marketmaking",
  initialState,
  reducers: {
    setTaskRow: (store, action: PayloadAction<ITaskTableReport>) => {
      store.taskRow = action.payload;
    },
    setEditTaskRow: (store, action: PayloadAction<IExecusionSearchParams>) => {
      store.editTask = action.payload;
    },
    setIsEdit: (store, action: PayloadAction<boolean>) => {
      store.isEdit = action.payload;
    },
    clearTaskRow: (store) => {
      store.taskRow = null;
      store.tabIndex = MarketmakingTableTabs.OrderTable;
    },
    openSettingModal: (store) => {
      store.modalMode = ModalMode.Setting;
    },
    openAddOrEditModal: (store) => {
      store.modalMode = ModalMode.AddOrEdit;
    },
    closeModal: (store) => {
      store.modalMode = ModalMode.Closed;
    },
    setTabIndex: (store, action: PayloadAction<MarketmakingTableTabs>) => {
      store.tabIndex = action.payload;
    },
  },
});

export const {
  setTaskRow,
  setEditTaskRow,
  setIsEdit,
  clearTaskRow,
  closeModal,
  openAddOrEditModal,
  openSettingModal,
  setTabIndex,
} = AutomaticMarketMakingSlice.actions;
export default AutomaticMarketMakingSlice.reducer;
